/* Siwon · LP pack antiedad */
(function(){
  var root=document.querySelector('.sw-lp'); if(!root) return;

  /* ══ AISLAR LA LANDING ══
     Oculta todo lo que cuelgue de <body> y no sea la landing: chat de Shopify Inbox,
     Smile, WhatsApp y cualquier widget que una app inyecte después de cargar.
     Da igual cómo se llame el elemento. El banner de cookies queda exento. */
  (function aislar(){
    var main=document.getElementById('MainContent')||root;
    var EXENTO=/cookie|consent|gdpr|isense|shopify-pc__banner/i;
    var NO_TOCAR=/^(SCRIPT|STYLE|NOSCRIPT|LINK|TEMPLATE|META)$/;
    function firma(el){ return (el.id||'')+' '+(typeof el.className==='string'?el.className:'')+' '+el.tagName.toLowerCase(); }
    function esChat(el){ try{ return !!(el.shadowRoot && el.shadowRoot.querySelector('.activator, .activator-nudge')); }catch(e){ return false; } }
    function barrer(){
      Array.prototype.slice.call(document.body.children).forEach(function(el){
        if(el===main || main.contains(el) || el.contains(main)) return;
        if(NO_TOCAR.test(el.tagName)) return;
        if(EXENTO.test(firma(el)) && !esChat(el)) return;
        el.style.setProperty('display','none','important');
      });
    }
    barrer();
    if('MutationObserver' in window){
      var mo=new MutationObserver(barrer);
      mo.observe(document.body,{childList:true});
      setTimeout(function(){ mo.disconnect(); },30000);
    }
    var n=0, iv=setInterval(function(){ barrer(); if(++n>=10) clearInterval(iv); },1500);
  })();
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO='IntersectionObserver' in window;

  /* Marquesina de prensa: se duplica antes de enganchar las imágenes */
  root.querySelectorAll('[data-loop]').forEach(function(track){
    if(reduce) return;
    track.innerHTML+=track.innerHTML;
    Array.prototype.slice.call(track.children,track.children.length/2).forEach(function(el){el.setAttribute('aria-hidden','true');});
  });

  /* Imágenes del CDN: si cargan tapan la reserva (dibujo o texto); si no, se queda la reserva */
  root.querySelectorAll('img[data-fb]').forEach(function(img){
    var box=img.closest('.sw-fb,.sw-lg');
    function ok(){ if(box) box.classList.add('has-img'); }
    function ko(){ img.remove(); }
    if(img.complete){ img.naturalWidth>0 ? ok() : ko(); }
    else{ img.addEventListener('load',ok); img.addEventListener('error',ko); }
  });

  /* Puntos de las 8 semanas */
  var stat=root.querySelector('[data-stat]');
  if(stat){
    if(hasIO && !reduce){ var sio=new IntersectionObserver(function(es){ if(es[0].isIntersecting){stat.classList.add('is-in');sio.disconnect();} },{threshold:.4}); sio.observe(stat); }
    else stat.classList.add('is-in');
  }

  /* Vídeos de expertos: solo cargan al pulsar y nunca suena ni corre más de uno */
  var vids=Array.prototype.slice.call(root.querySelectorAll('[data-vid]'));
  function stopOthers(me){ vids.forEach(function(o){ if(o===me) return; var ov=o.querySelector('video'); ov.pause(); ov.muted=true; o.querySelector('.sw-vid-sound').setAttribute('aria-pressed','false'); }); }
  vids.forEach(function(box){
    var v=box.querySelector('video'), play=box.querySelector('.sw-vid-play'), snd=box.querySelector('.sw-vid-sound');
    function setState(){ box.classList.toggle('is-playing',!v.paused); }
    function start(){ stopOthers(box); var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
    v.addEventListener('play',setState); v.addEventListener('pause',setState);
    play.addEventListener('click',function(){ v.paused ? start() : v.pause(); });
    snd.addEventListener('click',function(){ v.muted=!v.muted; snd.setAttribute('aria-pressed',v.muted?'false':'true'); if(v.paused) start(); });
  });
  if(hasIO){
    var vio=new IntersectionObserver(function(es){ es.forEach(function(e){ if(!e.isIntersecting){ var v=e.target.querySelector('video'); v.pause(); } }); },{threshold:.2});
    vids.forEach(function(b){vio.observe(b);});
  }

  /* Isla de compra: visible siempre que no haya un botón de compra en pantalla (móvil y escritorio) */
  var island=document.getElementById('swIsland');
  if(island && hasIO){
    var visible=new Set(), ready=false;
    setTimeout(function(){ready=true;sync();},900);
    function sync(){
      var on=ready && visible.size===0;
      island.classList.toggle('is-on',on);
      island.setAttribute('aria-hidden',on?'false':'true');
      var a=island.querySelector('a'); if(a) a.tabIndex=on?0:-1;
    }
    var buyIO=new IntersectionObserver(function(es){
      es.forEach(function(e){ e.isIntersecting?visible.add(e.target):visible.delete(e.target); });
      sync();
    },{threshold:.5});
    root.querySelectorAll('[data-buy]').forEach(function(b){buyIO.observe(b);});
  }

  /* TikTok: en móvil arranca centrado en el segundo vídeo, con los vecinos asomando */
  var rail=root.querySelector('[data-tt-rail]');
  if(rail && rail.scrollWidth>rail.clientWidth){ var second=rail.children[1]; if(second) rail.scrollLeft=second.offsetLeft-(rail.clientWidth-second.offsetWidth)/2; }

  /* Botón de compra: "Añadiendo…", alta en el carrito de Shopify (así los píxeles de Meta y TikTok registran AddToCart) y salto al checkout con el pack y los códigos */
  var ITEMS=[]; try{ ITEMS=JSON.parse(root.getAttribute('data-items')||'[]'); }catch(e){}
  root.querySelectorAll('[data-checkout]').forEach(function(a){
    var t=a.querySelector('.sw-btn-txt'); if(t) t.dataset.orig=t.textContent;
    a.addEventListener('click',function(ev){
      if(a.classList.contains('is-busy')){ ev.preventDefault(); return; }
      a.classList.add('is-busy'); a.setAttribute('aria-busy','true'); if(t) t.textContent='Añadiendo…';
      var go=function(){ location.href=a.href; };
      if(window.Shopify && window.fetch && ITEMS.length){
        ev.preventDefault();
        var done=false, finish=function(){ if(done) return; done=true; go(); };
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:ITEMS})}).then(finish,finish);
        setTimeout(finish,2500);
      }
    });
  });

  /* FAQ: al abrir una se cierran las demás */
  var faqs=root.querySelectorAll('.sw-faq details');
  faqs.forEach(function(d){ d.addEventListener('toggle',function(){ if(d.open) faqs.forEach(function(o){ if(o!==d) o.open=false; }); }); });
})();
